import { getContext } from '@/context';

type ReturnType = {
  jsonUrl: string | null;
};

const getProjectJsonUrl = (): ReturnType => {
  try {
    const { params } = getContext().general.location.getState();
    const { presetJsonUrl } = params;

    return { jsonUrl: (presetJsonUrl as string) || null };
  } catch {
    return { jsonUrl: null };
  }
};

export { getProjectJsonUrl };
